import { BaseService, Service } from "/@/cool";

@Service("baseSysParam")
class SysParam extends BaseService {}

export default SysParam;
